<template>
  <div class="slider-captcha">
    <!-- 触发滑动验证的按钮 -->
    <div class="captcha-trigger" @click="openCaptcha">
      <span v-if="!isVerified" class="trigger-text">点击完成滑动验证</span>
      <span v-else class="trigger-success">验证成功</span>
    </div>
    
    <!-- 滑动验证弹窗 -->
    <div v-if="showCaptcha" class="captcha-modal" @click.self="closeCaptcha">
      <div class="captcha-content">
        <div class="captcha-header">
          <h3>请完成安全验证</h3>
          <span class="close-btn" @click="closeCaptcha">&times;</span>
        </div>
        <div class="captcha-body">
          <div class="captcha-image-container">
            <div class="captcha-image-wrapper">
              <!-- 背景图片 -->
              <div class="captcha-bg"></div>
              
              <!-- 滑块图片（随滑块移动） -->
              <div 
                class="captcha-slider" 
                :style="{ 
                  left: sliderPosition + 'px'
                }"
              >
              </div>
            </div>
            
            <!-- 缺块位置指示器 -->
            <div 
              class="captcha-gap" 
              :style="{ left: gapPosition + 'px' }"
            >
              <svg width="48" height="48" viewBox="0 0 48 48">
                <path d="M0 0h48v48H0z" fill="rgba(255,255,255,0.8)" stroke="#1991FA" stroke-width="4.8"/>
              </svg>
            </div>
          </div>
          
          <div class="slider-container">
            <div class="slider-track"></div>
            <div 
              class="slider-fill" 
              :style="{ width: sliderPosition + 'px' }"
            ></div>
            <div 
              class="slider-handler" 
              :style="{ left: sliderPosition + 'px' }"
              @mousedown="startDrag"
              @touchstart="startDrag"
            >
            </div>
          </div>
          
          <div class="captcha-result" v-if="resultMessage">
            <span :class="resultClass">{{ resultMessage }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SliderCaptcha',
  data() {
    return {
      showCaptcha: false,
      isVerified: false,
      isDragging: false,
      startX: 0,
      sliderPosition: 0,
      gapPosition: 0,
      resultMessage: '',
      resultClass: ''
    }
  },
  mounted() {
    this.initCaptcha()
  },
  methods: {
    openCaptcha() {
      this.showCaptcha = true
      // 重新初始化验证码位置
      this.initCaptcha()
      // 重置验证状态
      this.isVerified = false
      this.resultMessage = ''
      this.resultClass = ''
    },
    
    initCaptcha() {
      // 初始化缺块位置（随机）
      this.gapPosition = Math.floor(Math.random() * 180) + 40
      this.resetSlider()
    },
    
    startDrag(e) {
      if (this.isVerified) return
      
      e.preventDefault()
      this.isDragging = true
      this.resultMessage = ''
      
      if (e.type === 'touchstart') {
        this.startX = e.touches[0].clientX
      } else {
        this.startX = e.clientX
      }
      
      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.stopDrag)
      document.addEventListener('touchmove', this.onDrag, { passive: false })
      document.addEventListener('touchend', this.stopDrag)
    },
    
    onDrag(e) {
      if (!this.isDragging) return
      
      e.preventDefault()
      
      let currentX
      if (e.type === 'touchmove') {
        currentX = e.touches[0].clientX
      } else {
        currentX = e.clientX
      }
      
      const rect = this.$el.querySelector('.captcha-image-wrapper').getBoundingClientRect()
      const deltaX = currentX - this.startX
      const maxPosition = rect.width - 48 // 最大滑动距离，与滑块宽度一致
      
      this.sliderPosition = Math.max(0, Math.min(deltaX, maxPosition))
    },
    
    stopDrag() {
      if (!this.isDragging) return
      
      this.isDragging = false
      
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.stopDrag)
      document.removeEventListener('touchmove', this.onDrag)
      document.removeEventListener('touchend', this.stopDrag)
      
      // 验证结果
      this.verifyResult()
    },
    
    verifyResult() {
      // 允许3px的误差，提高精度
      const tolerance = 3
      if (Math.abs(this.sliderPosition - this.gapPosition) <= tolerance) {
        this.isVerified = true
        this.resultMessage = '验证成功'
        this.resultClass = 'success'
        this.$emit('success')
        
        // 1秒后自动关闭
        setTimeout(() => {
          this.closeCaptcha()
        }, 1000)
      } else {
        this.resultMessage = '验证失败，请重新拖动'
        this.resultClass = 'error'
        this.$emit('fail')
        
        // 1秒后重置
        setTimeout(() => {
          this.resetSlider()
        }, 1000)
      }
    },
    
    resetSlider() {
      this.sliderPosition = 0
      this.resultMessage = ''
      this.resultClass = ''
    },
    
    closeCaptcha() {
      this.showCaptcha = false
      this.resetSlider()
      this.isVerified = false
    }
  }
}
</script>

<style scoped>
.slider-captcha {
  width: 100%;
}

.captcha-trigger {
  width: 100%;
  height: 40px;
  background: #f7f9fa;
  border: 1px solid #e4e7eb;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
}

.trigger-text {
  color: #999;
  font-size: 14px;
}

.trigger-success {
  color: #52c41a;
  font-size: 14px;
}

.captcha-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.captcha-content {
  width: 350px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.captcha-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #e8e8e8;
}

.captcha-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
}

.close-btn {
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.captcha-body {
  padding: 20px;
}

.captcha-image-container {
  position: relative;
  width: 100%;
  height: 155px;
  margin-bottom: 20px;
  overflow: hidden;
  border-radius: 4px;
}

.captcha-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  background: url('@/assets/c.png') center/cover no-repeat;
}

.captcha-bg {
  width: 100%;
  height: 100%;
  background: url('@/assets/c.png') center/cover no-repeat;
}

.captcha-slider {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 48px;
  height: 48px;
  background: url('@/assets/c.png') center/cover no-repeat;
  border: 1px solid #1991FA;
  box-shadow: 0 0 5px rgba(25, 145, 250, 0.5);
  box-sizing: border-box;
  z-index: 10;
}

.captcha-gap {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 48px;
  height: 48px;
  overflow: hidden;
  box-sizing: border-box;
  z-index: 5;
}

.slider-container {
  position: relative;
  width: 100%;
  height: 40px;
}

.slider-track {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f7f9fa;
  border: 1px solid #e4e7eb;
  border-radius: 4px;
}

.slider-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: #D1E9FE;
  border-radius: 4px;
}

.slider-handler {
  position: absolute;
  top: 0;
  left: 0;
  min-width: 60px;
  height: 40px;
  background: #fff;
  border: 1px solid #e4e7eb;
  border-radius: 4px;
  cursor: move;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #999;
  user-select: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s;
  padding: 0 10px;
  white-space: nowrap;
}

.slider-handler:hover {
  border-color: #1890ff;
}

.captcha-result {
  margin-top: 10px;
  text-align: center;
  min-height: 20px;
}

.success {
  color: #52c41a;
}

.error {
  color: #ff4d4f;
}
</style>